import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LogoMain from '../images/logo.svg'
import * as ctf from "contentful";
import HomeLogoSlider from "../../componetns/homePageSlider";

const MobileIndex = () => {
  const [banner, setBanner] = useState([]);
  const client = ctf.createClient({
    space: "fdtw7gymput4",
    accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
  });

  useEffect(() => {
    fetchDataHome();
  }, []);
  const fetchDataHome = async () => {
    try {
      const resp = await client.getEntries({ content_type: "homePage" });
      setBanner(resp.items);
    } catch (error) {
      console.log(error);
    }
  };

  const bannerVideo = banner[0]?.fields?.bannerVideos
  const n = 1;
  const posts = bannerVideo?.sort(() => Math.random() - 0.5).slice(0, n);
  return (
    <div>
      <div className="Mobile_header_idex text-center">
        <img src={LogoMain} alt="logo" />
      </div>
      <div className="home-bg-video-img">
        <video autoPlay loop muted playsInline>
          {posts != null && (
            <source src={`https:${posts[0].fields.file.url}`} type="video/mp4" />
          )}

        </video>
      </div>
      <div className="mobile_menu ">
        <div className="menu_links main-menu big">
          <ul className="mobile_all_links">
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/reels">Showreel</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            {/* <li>
              <Link to="/news">News</Link>
            </li> */}
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
        <HomeLogoSlider />
      </div>
    </div>
  );
};

export default MobileIndex;
